import React, { forwardRef } from 'react';
import { DateTimePicker } from '../UI/DateTimePicker';

export interface SignatureExpiresAtFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const SignatureExpiresAtField = forwardRef<HTMLInputElement, SignatureExpiresAtFieldProps>(({
  id = 'signature-expires-at',
  value,
  onChange,
  disabled = false,
}, ref) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Prazo para assinatura (opcional)
      </label>
      <p className="mt-0.5 text-xs text-gray-500">
        Escolha primeiro a data e depois o horário limite para concluir as assinaturas.
      </p>
      <div className="mt-1.5">
        <DateTimePicker
          ref={ref}
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          dateLabel="Data do prazo"
          timeLabel="Horário limite"
        />
      </div>
      <p className="mt-2 text-xs text-gray-500">
        Se informado, signatários receberão lembretes quando o prazo estiver em risco ou vencido.
      </p>
    </div>
  );
});

SignatureExpiresAtField.displayName = 'SignatureExpiresAtField';
